import _ from 'lodash'
import i18n from 'i18next'

// get error message by error code
export default function getErrorMessageByCode(code, customDefaultMessage=undefined) {

  return i18n.t([`omnitechError.${code}`, !_.isUndefined(customDefaultMessage)
      ? customDefaultMessage
      : _.isUndefined(code)
        ? i18n.t('omnitechError.default')
        : i18n.t('omnitechError.unspecific', { code: code })
    ])
}
